import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import CkEditor from 'src/components/editor'
import { useDispatch } from 'react-redux'
import { cardPatchAction, editorLoading } from 'src/reducers/card/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { QuestionFieldNames } from 'src/model/card'
import AnswerTypeFactory from 'src/components/answer-type/factory'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import {
  addCourseCreationMessageReceivedListener,
  startConnection,
} from 'src/utils/signalR-connection/signalR-connection'
import URL from 'src/api/url'
import { replaceContentById } from 'src/components/editor/utils'
import { useParams } from 'react-router-dom'

const DragDropEditor = props => {
  const { classes, data, isLoading } = props
  const dispatch = useDispatch()
  const [cardText, setCardText] = React.useState(data?.text)
  const { id, page, subPage } = useParams()

  const handleSocketMessage = () => {
    addCourseCreationMessageReceivedListener(async message => {
      const cardId = data?.id

      if (cardId?.toString() === message[0]) {
        const ınnerHtml = `<div class="img-wrapper">
                        <img src=${URL.STORAGE + message[1]} ></img>
                      </div>`
        replaceContentById('ai-image-loading', ınnerHtml)
      }
    })
  }
  useEffect(() => {
    startConnection()
    setTimeout(() => {
      handleSocketMessage()
    }, 2000)
  }, [data])

  useEffect(() => {
    setCardText(data?.text)
  }, [data])

  // Create stable reference using useCallback
  const onBlurText = value => {
    dispatch(editorLoading())
    dispatch(
      cardPatchAction(
        new PatchData(
          new PatchContent(
            value,
            QuestionFieldNames.QTEXT,
            PatchContent.OPERATION_REPLACE,
          ),
          data[QuestionFieldNames.ID],
        ),
        () => {
          setTimeout(() => {
            dispatch(editorLoading())
          }, 1000)
        },
      ),
    )
  }
  const { execute, update, exists, value } = useCourseSettings('theme')

  const font = value ? value.font : null
  const fontSize = value ? value.fontSize : null
  return data && !isLoading ? (
    <>
      <CkEditor
        initialData={cardText}
        saveData={value => {
          onBlurText(value)
        }}
        font={font}
        fontSize={fontSize}
        page={page}
        cardId={data?.id}
      />
      <div>
        {data &&
          AnswerTypeFactory({
            type: data[QuestionFieldNames.QUESTION_TYPE],
            dispatch,
            data,
          })}
      </div>
    </>
  ) : (
    ''
  )
}

export default withStyles(styles)(DragDropEditor)
